import { IDemo, E3DDemoNameVals, DemoIds } from 'types'
import { getSharedAsset } from '../../helpers/utils'

const video = getSharedAsset('shot-tracker.mp4', 'demos', 'videos')
const poster = getSharedAsset('shot-tracker.png', 'demos', 'posters')
const monolith = getSharedAsset('shot-tracker.png', 'demos', 'monoliths')
const nextDemoThumbnail = getSharedAsset('aerial-applications.png', 'sessions', 'thumbnails')

export const shotTracker: IDemo = {
  id: DemoIds.shotTracker,
  type: E3DDemoNameVals.shotTracker,
  video,
  monolith,
  poster,
  end: {
    header: '5G Edge and data driven decision making.',
    body: 'Learn how 5G and MEC can help breathe life into organizations’ more daring ideas.',
    nextDemoText: 'Geospatial data and analysis using drone services.',
    nextDemoId: DemoIds.aerialApplications,
    nextDemoThumbnail,
    previousDemoId: DemoIds.blueforce
  }
}
